import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';

function applyContentSecurityPolicy() {
  if (__SERVER__ && process.env.DISABLE_CSP !== 'true') {
    // Array: the factory returns one Router, and the caller spreads this.
    return [require('./middleware/securityHeaders').default()];
  }
  return [];
}

function applyConfig(config: ConfigType) {
  installSettings(config);

  if (__SERVER__ && process.env.NODE_ENV !== 'development') {
    const settings = config.settings as any;
    const serverConfig = settings.serverConfig || {};
    const existingMiddleware =
      serverConfig.expressMiddleware || settings.expressMiddleware || [];

    const expressMiddleware = [
      ...applyContentSecurityPolicy(),
      ...existingMiddleware,
    ];

    settings.serverConfig = {
      ...serverConfig,
      expressMiddleware,
    };
    settings.expressMiddleware = expressMiddleware;
  }

  return config;
}

export default applyConfig;
